import { Typography } from "antd";
import styled from "styled-components";

import { FONT_VARIANTS, FONT_WEIGHTS } from "../Typography.constants";
import { TTitleStyleProps } from "./Title.types";

export const TitleStyled = styled(Typography.Title)<TTitleStyleProps>`
    margin-top: 0;
    margin-bottom: ${props => props.$isMarginless
    ? "0 !important"
    : null};
    font-weight: ${props => FONT_WEIGHTS[props.$weight]} !important;
    text-align: ${props => props.$textAlign};
    ${props => FONT_VARIANTS[props.$variant]};
`;
